import { UserAuthModel } from '../models/user-auth.model';
import { UserAuthUIModel } from '../ui-models/user-auth.ui-model';

function mapToUI(userData: UserAuthModel): UserAuthUIModel {
  return {
    accessToken: userData.data.accessToken,
    refreshToken: userData.data.refreshToken,
    refreshTokenExpiresIn: userData.data.refreshTokenExpiresIn,
    tokenExpiresIn: userData.data.tokenExpiresIn,
    email: userData.data.email,
    userId: userData.data.userId,
    role: userData.data.role,
    roles: userData.data.roles
  };
}

export default {
  mapToUI
};
